<template>
  <tr v-if="item.type === 0">
    <td class="group_res">
      {{ name }}({{ item.online }} / {{ item.count }})
    </td>
  </tr>
  <tr v-else-if="item.type === -1">
    <td class="group_res">
      {{ translate('no_result') }}
    </td>
  </tr>
  <router-link v-else :to="go_to()">
    <tr class="link">
      <td v-if="checkbox" class="checkbox_table" :data-label="translate('checkit')">
        <input v-model="item.checked" :checked="checked" type="checkbox" @click.stop="check">
      </td>
      <td :data-label="translate('status')" class="status">
        <sis-icon-status :status="+item.active" />
      </td>
      <td :data-label="translate('simcard_devices.fid')">
        <router-link :to="{path: '/device/' + item.device_fid}">
          {{ item.device_fid }}
        </router-link>
      </td>
      <td :data-label="translate('simcard_devices.name')">
        {{ item.name }}
      </td>
      <td :data-label="translate('simcard_devices.number')">
        {{ item.number }}
      </td>
      <td :data-label="translate('simcard_devices.imsi')">
        {{ item.imsi }}
      </td>
      <td :data-label="translate('simcard_devices.iccid')">
        {{ item.iccid }}
      </td>
    </tr>
  </router-link>

</template>
<script>
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'

export default {
  name: 'SimCardDevicesListItem',
  components: {
    SisIconStatus
  },
  props: {
    item: Object,
    index: [Number, String],
    checked: [Number, String, Boolean],
    checkbox: {
      type: Boolean,
      default: true
    },
    groups: Array
  },
  data() {
    return {
      status: false,
      chartStatus: false,
      resize: false
    }
  },
  computed: {
    name() {
      if (this.item.type === 0) {
        return this.$store.getters.getSimcardDevicesGroupById(this.item.id).name
      }
      else {
        let name = this.item.name2
        if (this.$store.getters.getPermissions.permissionGod) {
          name += ' / '
          name += this.item.name
        }
        return name
      }
    },
  },
  activated() {
    this.$emit('mount', this.index)
  },
  mounted() {
    this.$emit('mount', this.index)
  },
  methods: {
    check() {
      this.$emit('check', !this.item.checked, this.item.device_id)
    },
    cntx_menu(e) {
      this.$emit('contextmenu', e, this.item)
    },
    go_to() {
      return { path: '/simcard_devices/' + this.item.imsi }
    },
    ready() {
      this.$emit('ready', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  margin-top: -1px;
  vertical-align: middle;
  &:hover{
    background-color: #f1f1f1;
    color: black;
  }
}

.group_res {
  cursor: auto;
}
</style>
